import { render, staticRenderFns } from "./PageForm.vue?vue&type=template&id=245b811c"
import script from "./PageForm.vue?vue&type=script&lang=js"
export * from "./PageForm.vue?vue&type=script&lang=js"
import style0 from "./PageForm.vue?vue&type=style&index=0&id=245b811c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports